export default "/assets/images/rookie-parent-small.f8721b21daa5d752.png";